export default __webpack_public_path__ + "static/media/award.f9a3c1e0.png";